<template>
  <mf-loading-dialog :loading="$apollo.loading || loadingFlow">
    <base-page-layout ref="basePage" :title="pageTitle" show-tour flow-id="ffd23e4a-3190-4544-bbf4-f63db1275c5f">
      <title-description
        data-userflow-id="title-description"
        class="mb-4"
        mode="WHATSAPP_FLOW"
        :title.sync="flowMenu.title"
        :description.sync="flowMenu.description"
        :title-error="$v.flowMenu.title.$error"
        :title-error-message="errorTitle"
        :description-error="$v.flowMenu.description && $v.flowMenu.description.$error"
        :status="flowMenu.active ? 'ACTIVE' : 'DRAFT'"
        :description-error-message="errorDescription"
      />
      <v-row>
        <v-col>
          <whatsapp-numbers-configuration
            data-userflow-id="whatsapp-numbers-configuration"
            :selected-whatsapp-numbers.sync="flowMenu.registers"
            :error="errorRegisters"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>Chatbot</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <preview-flow
                    data-userflow-id="whatsapp-preview"
                    :menu-options="menuOptions"
                    :menu-message="flowMenu.message"
                    :selected-menu-option-messages="selectedMenuOptionMessages"
                  />
                </v-col>
                <v-col cols="6">
                  <mf-tabs-menu v-model="templateTab" :tabs="tabsMenuItems" :tabs-errors="errorTabs" class="mb-4" />
                  <div v-if="templateTab === 0">
                    <new-flow-option @newOption="newOption" />
                    <v-data-table
                      class="menu-options-table"
                      :items="menuOptions"
                      :headers="menuOptionsHeaders"
                      hide-default-footer
                      disable-pagination
                      disable-sort
                      :height="200"
                      fixed-header
                    >
                      <template v-slot:item="props">
                        <tr
                          :class="[
                            'clickable',
                            selectedMenuOptionIndex === props.index ? 'v-data-table__selected' : '',
                            isMenuOptionError(props.index) ? 'error--text' : '',
                          ]"
                          @click="selectMenuOption(props.index)"
                        >
                          <td>{{ props.item.position }}</td>
                          <td>
                            <mf-icon fill small :color="getStatusLabel(props.item.active ? 'ACTIVE' : 'DRAFT').color">fiber_manual_record</mf-icon>
                            {{ props.item.active ? 'Ativo' : 'Desativado' }}
                          </td>
                          <td>
                            <v-tooltip right max-width="250">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  {{ props.item.menu_name | hifen | truncate({ length: 48 }) }}
                                </span>
                              </template>
                              <span style="word-wrap: break-word; word-break: break-all">{{ props.item.menu_name }}</span>
                            </v-tooltip>
                          </td>
                          <td>{{ flowHandleToDescription[props.item.flow.handle] }}</td>
                          <td>
                            <v-menu>
                              <template v-slot:activator="{ on }">
                                <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                              </template>
                              <v-list>
                                <v-list-item @click="selectMenuOption(props.index)">
                                  <v-list-item-title>Editar</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="deleteMenuOption(props.index)">
                                  <v-list-item-title>Apagar</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="props.index !== 0" @click="moveMenuOption(props.index, props.index - 1)">
                                  <v-list-item-title>Mover para cima</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="props.index !== menuOptions.length - 1" @click="moveMenuOption(props.index, props.index + 1)">
                                  <v-list-item-title>Mover para baixo</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <span v-if="errorEmptyMenuOptions" class="error--text">{{ errorEmptyMenuOptions }}</span>
                    <v-divider />
                    <flow-configuration
                      id="flow-configuration"
                      ref="selectedFlowConfiguration"
                      :selected-menu-option="selectedMenuOption"
                      :selected-menu-option-position="selectedMenuOptionPosition"
                      @input="(evt) => changeSelectedMenuOption(evt, selectedMenuOptionIndex)"
                    />
                  </div>
                  <div v-if="templateTab === 1">
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <mf-textarea-emoji
                          v-model="flowMenu.message"
                          class="textarea"
                          outlined
                          no-resize
                          rows="8"
                          hide-counter
                          :max-length="0"
                          :error-messages="errorMessage"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <mf-action-buttons
        v-if="flowMenu.active"
        :primary-button="{
          text: 'Salvar alterações',
          action: () => submit({ isDraft: false, loader: 'active.submit' }),
          isVisible: true,
          isLoading: $wait.is('active.submit'),
          isDisabled: $wait.any,
        }"
        :secondary-button="{
          text: 'Salvar e Desativar',
          action: () => confirmDisable({ loader: 'active.disable' }),
          isVisible: true,
          isDisabled: $wait.any,
          isLoading: $wait.is('active.disable'),
        }"
        :extra-button="{
          text: 'Apagar fluxo',
          action: () => remove({ loader: 'draft.remove' }),
          isVisible: !newFlowMenu,
          isDisabled: $wait.any,
          isLoading: $wait.is('draft.remove'),
        }"
        :cancel-button="{
          text: 'Cancelar',
          action: cancel,
          isVisible: true,
          isDisabled: $wait.any,
        }"
      />
      <mf-action-buttons
        v-else
        :primary-button="{
          text: 'Ativar campanha',
          action: () => submit({ isDraft: false, loader: 'draft.submit' }),
          isVisible: true,
          isLoading: $wait.is('draft.submit'),
          isDisabled: $wait.any,
        }"
        :secondary-button="{
          text: 'Salvar rascunho',
          action: () => submit({ isDraft: true, loader: 'draft.submitAsDraft' }),
          isVisible: true,
          isLoading: $wait.is('draft.submitAsDraft'),
          isDisabled: $wait.any,
        }"
        :extra-button="{
          text: 'Apagar fluxo',
          action: () => remove({ loader: 'draft.remove' }),
          isVisible: !newFlowMenu,
          isDisabled: $wait.any,
          isLoading: $wait.is('draft.remove'),
        }"
        :cancel-button="{
          text: 'Cancelar',
          action: cancel,
          isVisible: true,
          isDisabled: $wait.any,
        }"
      />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import { notOnlySpace, mustHaveString } from '@/helpers/validators.js'
import { flowValidator } from '@/modules/campanhas/whatsapp/validations/flows.js'
import { getStatusLabel } from '@/config/helpers.js'
import {
  QUERY_WHATSAPP_FLOW_MENUS,
  MUTATION_UPSERT_FLOW_MENU,
  MUTATION_UPSERT_DRAFT_FLOW_MENU,
  MUTATION_DELETE_FLOW_MENU,
  GET_FLOW,
} from '@/modules/campanhas/whatsapp/graphql/index.js'

import Swal from 'sweetalert2'

const DEFAULT_MENU_MESSAGE = 'Veja as nossas opções:\n[menu]\nDigite o número da opção desejada:'

export default {
  components: {
    BasePageLayout,
    WhatsappNumbersConfiguration: () => import('@/modules/campanhas/whatsapp/views/components/WhatsappNumbersConfiguration.vue'),
    PreviewFlow: () => import('@/modules/campanhas/whatsapp/views/components/PreviewFlow.vue'),
    FlowConfiguration: () => import('@/modules/campanhas/whatsapp/views/components/FlowConfiguration.vue'),
    NewFlowOption: () => import('@/modules/campanhas/whatsapp/views/components/NewFlowOption.vue'),
    TitleDescription: () => import('@/modules/campanhas/views/components/edit/TitleDescription.vue'),
  },
  props: {
    newFlowMenu: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tryingToSaveAsDraft: true,
    selectedMenuOption: null,
    selectedMenuOptionIndex: -1,
    loadingFlow: false,
    templateTab: 0,
    selectedMenuOptionMessages: [],
    flowId: '',
    flowMenu: {
      title: '',
      description: '',
      registers: [],
      message: DEFAULT_MENU_MESSAGE,
      menu_options: [],
    },
  }),
  computed: {
    pageTitle() {
      if (this.newFlowMenu) return 'Novo fluxo'
      else return 'Editar fluxo'
    },
    menuOptions() {
      let position = 1
      return this.flowMenu.menu_options.map((option) => {
        if (option.active) {
          option.position = position
          position += 1
        } else {
          option.position = '-'
        }
        return option
      })
    },

    flowHandleToDescription() {
      return {
        simple_response: 'Resposta simples',
        forward_to_sender: 'Encaminhar para disparador',
      }
    },

    menuOptionsHeaders() {
      return [
        { text: '#', value: 'position', width: '5%' },
        { text: 'Status', value: 'position', width: '15%' },
        { text: 'Nome', value: 'menu_name', width: '50%' },
        { text: 'Tipo', value: 'flowMenu.handle', width: '25%' },
        { text: '', value: 'flowMenu.handle', width: '5%' },
      ]
    },

    errorTitle() {
      if (!this.$v.flowMenu.title) return ''
      if (this.$v.flowMenu.title.$error) {
        if (!this.$v.flowMenu.title.required) return 'Dê um nome para este fluxo.'
        else if (!this.$v.flowMenu.title.minLength) return 'O título possui menos de 2 caracteres.'
        else if (!this.$v.flowMenu.title.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
    errorRegisters() {
      if (!this.$v.flowMenu.registers) return ''
      if (this.$v.flowMenu.registers.$error) {
        return 'Selecione ao menos um número do whatsapp para este fluxo.'
      }
      return ''
    },
    errorDescription() {
      if (!this.$v.flowMenu.description) return ''
      if (this.$v.flowMenu.description.$error) {
        if (!this.$v.flowMenu.description.required) return 'Informe detalhes para melhor identificação do fluxo.'
        else if (!this.$v.flowMenu.description.minLength) return 'A descrição possui menos de 2 caracteres.'
        else if (!this.$v.flowMenu.description.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      } else return ''
      return ''
    },
    errorMessage() {
      if (!this.flowMenu.message.includes('[menu]')) return 'Mensagem do menu precisa ter a variável [menu].'
      return ''
    },
    errorEmptyMenuOptions() {
      if (this.$v.flowMenu?.menu_options?.$error && !this.$v.flowMenu?.menu_options?.required) return 'É necessário configurar no mínimo uma opção do fluxo'
      return ''
    },
    errorTabs() {
      const errorTabs = []
      if (this.errorEmptyMenuOptions || this.$refs.selectedFlowConfiguration?.isErrored() || this.$v.flowMenu.menu_options?.$error) {
        errorTabs.push(0)
      }
      if (this.errorMessage) {
        errorTabs.push(1)
      }
      return errorTabs
    },
    selectedMenuOptionPosition() {
      if (this.selectedMenuOptionIndex < 0) {
        return 0
      }
      return this.flowMenu.menu_options[this.selectedMenuOptionIndex].position
    },
    tabsMenuItems() {
      return [
        {
          name: 'Configurar opções',
        },
        {
          name: 'Editar texto do menu',
        },
      ]
    },
  },
  async mounted() {
    this.flowId = this.$route.params.id
    if (this.flowId) {
      await this.fetchFlow()
    }
  },
  methods: {
    getStatusLabel,
    isMenuOptionError(index) {
      return this.$v?.flowMenu?.menu_options?.$each?.[index]?.$error
    },
    selectMenuOption(index) {
      this.selectedMenuOption = this.flowMenu.menu_options[index]
      this.selectedMenuOptionIndex = index
      this.$nextTick(this.setSelectedMenuOptionMessages)
    },
    changeSelectedMenuOption(newMenuOption, index) {
      this.$set(this.flowMenu.menu_options, index, newMenuOption)
      this.setSelectedMenuOptionMessages()
    },
    setSelectedMenuOptionMessages() {
      let messages = [
        {
          fromBot: false,
          text: `${this.selectedMenuOptionPosition}`,
        },
      ]
      if (this.$refs.selectedFlowConfiguration) {
        const selectedFlowMessages = this.$refs.selectedFlowConfiguration.computeMessages()
        if (selectedFlowMessages?.length) {
          messages = messages.concat(selectedFlowMessages)
        }
      }

      this.selectedMenuOptionMessages = messages
    },
    newOption({ id, handle }) {
      this.flowMenu.menu_options.push({
        menu_name: '',
        active: true,
        flow: {
          id,
          handle,
        },
      })
      this.selectMenuOption(this.flowMenu.menu_options.length - 1)
    },

    deleteMenuOption(index) {
      if (this.selectedMenuOptionIndex === index) {
        this.selectedMenuOption = null
        this.selectedMenuOptionIndex = -1
      } else if (this.selectedMenuOptionIndex > index) {
        this.selectedMenuOptionIndex -= 1
      }
      this.flowMenu.menu_options.splice(index, 1)
    },
    moveMenuOption(oldPosition, newPosition) {
      const [element] = this.flowMenu.menu_options.splice(oldPosition, 1)
      this.flowMenu.menu_options.splice(newPosition, 0, element)
    },
    async fetchFlow() {
      this.loadingFlow = true
      try {
        const {
          data: { whatsappFlowMenu },
        } = await this.$apollo.query({
          query: GET_FLOW,
          notifyOnNetworkStatusChange: true,
          variables: {
            _id: this.flowId,
          },
          fetchPolicy: 'no-cache',
        })
        this.flowMenu = whatsappFlowMenu
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Erro ao carregar fluxo.', snackbarColor: 'error' })
      }
      this.loadingFlow = false
    },
    getFlowToSave() {
      const flow = {
        title: this.flowMenu.title,
        description: this.flowMenu.description,
        registers: this.flowMenu.registers.map((register) => register.number),
        message: this.flowMenu.message,
        menu_options: this.flowMenu.menu_options.map((menuOption) => {
          const processedMenuOption = {
            active: menuOption.active,
            menu_name: menuOption.menu_name,
          }
          switch (menuOption.flow.handle) {
            case 'simple_response':
              processedMenuOption.flow = {
                id: menuOption.flow.id,
                handle: menuOption.flow.handle,
                message: menuOption.flow.message,
              }
              break
            case 'forward_to_sender':
              processedMenuOption.flow = {
                id: menuOption.flow.id,
                handle: menuOption.flow.handle,
                forward_registers: menuOption.flow.forward_registers.map((register) => ({
                  number: register.number,
                  units: register.units.map((unit) => unit.id_erp),
                })),
                send_contact_message: menuOption.flow.send_contact_message,
                start_register_chat_content: menuOption.flow.start_register_chat_content,
                select_federative_unit_message: menuOption.flow.select_federative_unit_message,
                select_city_message: menuOption.flow.select_city_message,
                select_unit_message: menuOption.flow.select_unit_message,
              }
              break
          }
          return processedMenuOption
        }),
      }
      if (this.flowMenu._id) {
        flow._id = this.flowMenu._id
      }
      return flow
    },
    returnToHome() {
      this.$router.push('/campanhas/whatsapp?tab=3').catch(() => {})
    },
    cancel() {
      this.$confirm({ message: 'Todas as alterações serão descartadas.', confirmText: 'Ok', cancelText: 'Cancelar' })
        .then(() => {
          this.returnToHome()
        })
        .catch(() => {})
    },
    confirmDisable({ loader }) {
      this.$confirm({
        title: 'Desativar fluxo',
        message: 'Deseja desativar este fluxo?',
        confirmText: 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.submit({ isDraft: true, loader: loader })
        })
        .catch(() => {})
    },
    async checkIfOtherFlowsExistWithRegisters({ registers, _id }) {
      const { data } = await this.$apollo.query({
        query: QUERY_WHATSAPP_FLOW_MENUS,
        variables: {
          registers,
          page: 1,
          pageSize: 9999,
          active: true,
        },
      })
      if (data.whatsappFlowMenus.whatsappFlowMenus.some((menu) => menu._id !== _id)) {
        throw Error(`Other flows exist attached with the same numbers.`)
      }
    },
    async submit({ isDraft, loader }) {
      this.tryingToSaveAsDraft = isDraft
      this.$v.$reset()
      this.$v.$touch()

      const selectedFlowError = this.$refs.selectedFlowConfiguration?.validate()
      if (this.$v.$error || selectedFlowError) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text, .tabs-menu__error-badge'), { offset: 200 })
        })

        return
      }
      this.$wait.start(loader)
      const flowToSave = this.getFlowToSave()
      if (!isDraft) {
        try {
          await this.checkIfOtherFlowsExistWithRegisters(flowToSave)
        } catch (e) {
          console.warn(e)
          this.$snackbar({ message: 'Outros fluxos já estão ativos com estes números do whatsapp.', snackbarColor: 'error' })
          this.$wait.end(loader)
          return
        }
      }

      try {
        await this.$apollo.mutate({
          mutation: isDraft ? MUTATION_UPSERT_DRAFT_FLOW_MENU : MUTATION_UPSERT_FLOW_MENU,
          variables: {
            data: flowToSave,
          },
        })

        Swal.fire({
          text: 'Fluxo salvo',
          icon: 'success',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
        this.returnToHome()
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao salvar fluxo.', snackbarColor: 'error' })
      } finally {
        this.$wait.end(loader)
      }
    },
    async remove({ loader }) {
      try {
        this.$confirm({
          title: 'Remover fluxo',
          message: 'Tem certeza que deseja remover este fluxo?',
          confirmText: 'Remover',
          confirmColor: 'vermelho-d20',
          cancelText: 'Cancelar',
        })
          .then(async () => {
            this.$wait.start(loader)

            await this.$apollo.mutate({
              mutation: MUTATION_DELETE_FLOW_MENU,
              variables: {
                _id: this.flowId,
              },
            })

            this.$wait.end(loader)

            this.$snackbar({ message: 'Fluxo apagado.', snackbarColor: 'success' })
            this.returnToHome()
          })
          .catch(() => {})
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao apagar fluxo.', snackbarColor: 'error' })
      }
    },
  },
  validations() {
    if (this.tryingToSaveAsDraft) {
      return {
        flowMenu: {
          title: { required, minLength: minLength(2), notOnlySpace },
          message: {
            required,
            mustHavestring: mustHaveString('[menu]'),
          },
        },
      }
    }
    return {
      flowMenu: {
        title: { required, minLength: minLength(2), notOnlySpace },
        message: {
          required,
          mustHavestring: mustHaveString('[menu]'),
        },
        registers: {
          required,
          minLength: minLength(1),
        },
        menu_options: {
          required,
          $each: {
            menu_name: {
              required,
              minLength: minLength(1),
              notOnlySpace,
            },
            flow: {
              forward_to_sender: flowValidator('forward_to_sender'),
              simple_response: flowValidator('simple_response'),
            },
          },
        },
      },
    }
  },
}
</script>
